export default {
  primary: '#1D00FF',
  primaryAssist: '#FFFFFF',
  highlight: '#FFFFFF',
  text: '#000000',
  textAssist: '#5959FF',
  label: '#7F7FFF',
  button: '#BFBFFF',
  link: '#0000FF',
  background: '#E0E0FF',
  backgroundAssist: '#F5F5FF',
  border: '#BFBFFF',
  blue0: 'rgba(0, 0, 255, 0)',
  blue50: 'rgba(0, 0, 255, 0.50)',
  blue65: 'rgba(0, 0, 255, 0.65)',
  blue85: 'rgba(0, 0, 255, 0.85)',
  white: 'white',
};



// WEBPACK FOOTER //
// ./src/assets/color.js